import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import MainComponent from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "antd/dist/reset.css";
import { PersistGate } from "redux-persist/integration/react";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    {/*<StartNotifications />*/}
    <PersistGate loading={null} persistor={persistor}>
      <MainComponent />
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
